import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["Button", "useContentContainer", "onInsertComplete", "resetSelectedType", "onInsertContent", "onOpenPopover"];
import { useCallback, useState, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../../contexts/useDebouncedEditorStateContext';
import { buildDocumentLinkTr, buildDocumentPreviewTr } from '../../utils/documentUtils';
import DocumentsPopover from './DocumentsPopover';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { DocumentsIcon } from 'foundations-assets/icons/components/DocumentsIcon';

/** Configuration for the Documents insert capability (shareable document links) */
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentsButton = ({
  onClick
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubspot-prosemirror.tooltips.insertDocuments"
  }),
  children: /*#__PURE__*/_jsx(RTEToolbarButton, {
    "data-test-id": "documents",
    onClick: onClick,
    selected: false,
    children: /*#__PURE__*/_jsx(TextToolbarIcon, {
      icon: DocumentsIcon
    })
  })
});
export default function InsertDocuments(_ref) {
  let {
      Button = DocumentsButton,
      useContentContainer,
      onInsertComplete = () => {},
      resetSelectedType = () => {},
      onInsertContent = () => {},
      onOpenPopover = () => {}
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const [open, setOpen] = useState(false);
  const includePrefixedDocumentId = Boolean(props.renderDocumentFn);
  const insertDocuments = useCallback(({
    documentId,
    documentName,
    displayText,
    requireEmail,
    includeLinkPreview,
    previewTitle,
    previewImage,
    linkInfo,
    allowDownload
  }) => {
    const tr = buildDocumentLinkTr({
      documentId,
      documentName,
      displayText,
      requireEmail,
      linkInfo,
      allowDownload,
      editorState,
      includePrefixedDocumentId
    });
    const newState = editorState.apply(tr);
    const trWithPreview = buildDocumentPreviewTr({
      documentId,
      documentName,
      requireEmail,
      previewTitle,
      previewImage,
      description: '',
      linkInfo,
      includeLinkPreview,
      editorState: newState,
      includePrefixedDocumentId
    });
    setEditorState(newState.apply(trWithPreview));
    onInsertComplete();
    onInsertContent();
  }, [editorState, setEditorState, onInsertComplete, onInsertContent, includePrefixedDocumentId]);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const onOpenChange = useCallback(e => {
    setOpen(e.target.value);
  }, [setOpen]);
  const DocumentsPopoverContainer = useMemo(() => {
    if (useContentContainer) {
      return /*#__PURE__*/_jsx(DocumentsPopover, Object.assign({}, props, {
        onChange: insertDocuments,
        onClose: resetSelectedType
      }));
    }
    return /*#__PURE__*/_jsx(Popover, {
      open: open,
      onOpenChange: onOpenChange,
      content: /*#__PURE__*/_jsx(DocumentsPopover, Object.assign({}, props, {
        onChange: insertDocuments,
        onClose: handleClose
      })),
      children: /*#__PURE__*/_jsx(Button, {
        onClick: () => {
          if (!open) {
            onOpenPopover();
          }
          setOpen(!open);
        }
      })
    });
  }, [Button, handleClose, insertDocuments, onOpenChange, onOpenPopover, open, props, resetSelectedType, useContentContainer]);
  return DocumentsPopoverContainer;
}